import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Chip, TableCell, TableRow } from '@mui/material';
import { HTMLAttributes } from 'react';
import dayjs from 'dayjs';
import { DISPLAY_DATETIME_12H_FORMAT } from '@/utils/dateHelper';
import DehazeIcon from '@mui/icons-material/Dehaze';
import { useTranslation } from 'react-i18next';
import { showLabel } from '@/utils/helper';
import { OnoffType } from '@/api/enum/common.enum';

type Props = {
	item: any;
} & HTMLAttributes<HTMLDivElement>;

const SortableArticlesItem = ({ item }: Props) => {
	const { t } = useTranslation();
	const {
		attributes,
		isDragging,
		listeners,
		setNodeRef,
		transform,
		transition,
	} = useSortable({
		id: item.id,
	});

	const statusList = [
		{ id: OnoffType.off, name: t('day21.off') },
		{ id: OnoffType.on, name: t('day21.on') },
	];

	const exerciseTypeList = [
		{ id: 1, name: t('day21.audio') },
		{ id: 2, name: t('day21.video') },
	];
	const canList = [
		{ id: true, name: t('day21.can') },
		{ id: false, name: t('day21.cannot') },
	];
	const styles = {
		transform: CSS.Transform.toString(transform),
		transition: transition || undefined,
		opacity: isDragging ? '0.4' : '1',
		backgroundColor: isDragging ? '#F5F5F5' : '',
	};

	return (
		<>
			<TableRow ref={setNodeRef} style={styles}>
				<TableCell component='th' scope='row'>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<DehazeIcon cursor={'pointer'} {...listeners} {...attributes} />
						{`${item.serialNumber || '-'}`}
					</Box>
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${item?.titleZh}`}
				</TableCell>
				<TableCell component='th' scope='row'>
					{showLabel(item?.mediaType, exerciseTypeList)}
				</TableCell>
				<TableCell component='th' scope='row'>
					{showLabel(item?.canCountTime, canList)}
				</TableCell>
				<TableCell component='th' scope='row'>
					{showLabel(item.canCollectPoints, canList)}
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${item?.reward || '-'}`}
				</TableCell>
				<TableCell component='th' scope='row'>
					{
						<Chip
							color={item?.status == OnoffType.on ? 'chipPrimary' : 'default'}
							label={showLabel(item?.status, statusList)}
						/>
					}
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${
						!item.updatedAt
							? '-'
							: dayjs(item.updatedAt)
									.locale('en')
									.format(DISPLAY_DATETIME_12H_FORMAT)
					}`}
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${
						!item.createdAt
							? '-'
							: dayjs(item.createdAt)
									.locale('en')
									.format(DISPLAY_DATETIME_12H_FORMAT)
					}`}
				</TableCell>
			</TableRow>
		</>
	);
};

export default SortableArticlesItem;
